<template>
    <div class=" uk-padding  uk-margin-remove-top" uk-scrollspy="target: > div; cls:uk-animation-fade; delay: 100">

        <h1  class="uk-heading-line uk-text-center specHeading" ><span>Featured Stories</span> </h1>

        <div class="uk-container uk-container-small">

            <div uk-slider>

                <div class="uk-position-relative">

                    <div class="uk-slider-container uk-light">
                        <ul class="uk-slider-items uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m">
                            <li class="uk-padding-small "  v-for="(item, key) in getFeatures" :key="key">

                                <div class="uk-card " >
                                    <div class="uk-card-media-top uk-padding-small uk-padding-remove-bottom" >

                                        <img :src="item.acf.story_cover_image" alt="" style="width: 100%; border-radius: 15px">
                                    </div>
                                    <div class="uk-card-body uk-padding-small">
                                        <h4 class="  " style="color: black !important;">{{item.title.rendered}}</h4>

                                        <!--<p class="uk-text-small " style="color: #666666;" v-html="item.featureArticle.substring(0, 110)">
                                        </p>-->
                                        <button :id="item.slug"
                                                v-on:click="findFeature"
                                                class="uk-align-right@l uk-align-center@s uk-button uk-button-default uk-button-small "
                                                style="background-color: transparent; border: 1px solid silver; color: #666"

                                        >

                                            Read More ..</button>

                                    </div>
                                </div>
                            </li>


                        </ul>
                    </div>

                    <div class="uk-hidden@s uk-light">
                        <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                        <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
                    </div>

                    <div class="uk-visible@s">
                        <a class="uk-position-center-left-out uk-position-small" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                        <a class="uk-position-center-right-out uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
                    </div>

                </div>
                <div>
                    <router-link to="/allfeaturestories" class="try uk-button uk-button-default uk-button-small uk-text-bold uk-align-right@l" >See More Stories ></router-link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "featureStorySnip",
        data(){
            return {
                feature: [],
            }
        },
        methods: {
            findFeature: function(event){
                //this.$store.commit('getArticle', (event.target.id))
                this.$router.push({ path: '/featurestory', query: { article: event.target.id }})
            }
        },
        computed: {
            getFeatures: function () {
                // `this` points to the vm instance
                return this.$store.state.FeatureStoriesList
            }

        },
        beforeCreate(){
            this.$store.commit('getFeatures')
        }
    }
</script>

<style scoped>
    #headers{
        font-family: "Alegreya SC";

    }
    @media screen and (max-width:600px){


        h1{
            font-size: 1.8em !important;
        }
        p{
            font-size: 0.7em !important;
        }

        h4{
            font-size: 1em !important;
        }
        .try{
            font-size: 0.6em !important;
            width: 140px;
        }

    }
</style>
